const e = "_menuDivider_1i998_1", i = {
  menuDivider: e
};
export {
  i as default,
  e as menuDivider
};
//# sourceMappingURL=MenuDivider.module.css.js.map
